import axios from 'axios'

import store from '../../redux/store'
import { setAuthData } from '../../../features/global'
import { loadLocalStorage, removeAllLocalStorage, saveLocalStorage } from '../../utils'

import {
  PRIVATE_DOCUMENTUM_INSTANCE_CONFIG,
  PRIVATE_REGISTRO_INSTANCE_CONFIG,
  PRIVATE_WEB_INSTANCE_CONFIG,
  PUBLIC_REGISTRO_INSTANCE_CONFIG,
  PUBLIC_WEB_INSTANCE_CONFIG,
} from '../constants'

// Create instances for WEB API
const publicWebInstance = axios.create(PUBLIC_WEB_INSTANCE_CONFIG)
const privateWebInstance = axios.create(PRIVATE_WEB_INSTANCE_CONFIG)

// Create instances for REGISTRO API
const publicRegistroInstance = axios.create(PUBLIC_REGISTRO_INSTANCE_CONFIG)
const privateRegistroInstance = axios.create(PRIVATE_REGISTRO_INSTANCE_CONFIG)

// Create instances for DOCUMENTUM API
const privateDocumentumInstance = axios.create(PRIVATE_DOCUMENTUM_INSTANCE_CONFIG)

const configurePrivateInstance = (instance) => {
  instance.interceptors.request.use((request) => {
    const userState = loadLocalStorage('userData')
    const obfuscationToken = store.getState().global.authData.obfuscationToken
    const language = loadLocalStorage('language')

    if (userState?.access_token) {
      request.headers.Authorization = 'Bearer ' + userState.access_token
    }
    if (obfuscationToken?.token) {
      request.headers['JWT-Token'] = obfuscationToken.token
    }
    if (language) {
      request.headers['Accept-Language'] = language
    }
    return request
  })

  let refreshTokenPool = { requestCount: 0, promise: null }

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { status, config } = error.response || {}
      const userState = loadLocalStorage('userData')

      if (config.url === 'refresh' || status !== 401 || error.config.retry) {
        throw error
      }

      if (!userState?.refresh_token) {
        console.error('No refresh token available')
        saveLocalStorage('glp', {})
        setTimeout(() => window.location.reload(), 1000)
        throw new Error('token_refresh_failure')
      }

      try {
        if (!refreshTokenPool.promise) {
          const payload = { refresh_token: userState.refresh_token, username: userState.username }
          refreshTokenPool.promise = privateWebInstance
            .post('refresh', payload)
            .then((response) => {
              const newUserData = { ...userState, ...response.data }
              saveLocalStorage('userData', newUserData)
              store.dispatch(setAuthData({ ...newUserData, isAuthorized: true }))
              return response
            })
            .catch((refreshError) => {
              removeAllLocalStorage()
              console.error('Token refresh failed', refreshError)
              throw new Error('token_refresh_failure')
            })
          refreshTokenPool.requestCount = 1
        } else {
          refreshTokenPool.requestCount++
        }

        const refreshResponse = await refreshTokenPool.promise
        refreshTokenPool.requestCount--

        if (refreshTokenPool.requestCount === 0) {
          refreshTokenPool.promise = null
        }
        const newRequestConfig = {
          ...config,
          retry: true,
          headers: { ...config.headers, Authorization: 'Bearer ' + refreshResponse.data.token },
        }
        return instance(newRequestConfig)
      } catch (refreshError) {
        saveLocalStorage('glp', {})
        setTimeout(() => window.location.reload(), 1000)
        throw new Error('token_refresh_failure')
      }
    }
  )
}

configurePrivateInstance(privateWebInstance)
configurePrivateInstance(privateRegistroInstance)
configurePrivateInstance(privateDocumentumInstance)

export const instances = {
  publicWebInstance,
  privateWebInstance,
  publicRegistroInstance,
  privateRegistroInstance,
  privateDocumentumInstance,
}
